import communityWalkthrough from '../../modules/community/walkthrough/xh.json';

export const XH = {
  translation: {
    ...communityWalkthrough,
  },
};
